// Called by : src/App.vue (router-view)

<template>
  <div id="page_question">

    {{ forceUpdate }}

    <modal-dico v-if="isDico" :dictionary="lesson.dictionary" :key="keyDico"></modal-dico>

    <h1 id="page_question_title" class="page_title mb-4 px-2 " :class="getClassTitle()">
      <span class="ui_tip float-right mt-2 ml-5" v-bind:title="lesson.langInfos">
        <country-flag :country="flag" size='big' class="qst_flag" />
      </span>
      <span v-if="isDico" class="lec_dico float-right mt-2">
        <button id="lec_dico" ref="LecDico" :title="$t('infos.dico')" class="btn_lec_dico ui_tip" data-toggle="modal" data-target="#pge_dico">
          <img id="icn_dic" :src="constants.assets.iconLecDicoBlack" alt="icon-dictionary" class="icn_lec_dico mr-2" ref="rDic" @error="onDicIconError(this.id)">
        </button>
      </span>
      <sound-player v-if="question.order < 2" :url="lesson.audioTitle" role="lessonTitle" tone="btn-outline-primary"></sound-player>
      {{ lesson.name }}
    </h1>

    <div id="qst_cont" class="question card text-left ">

      <div id="qst_cont_tete" class="card-header h2 text-white txt_ombre_333 " :class="getClassTete()">
        <p class="qst_index float-right">
          <span class="badge badge-pill badge-dark py-0 m-0">
            <button class="btn btn-dark border-0 px-2 py-1 m-0" @click.stop="getPrevQuestion()">
              <span v-if="modeShow" class="oi oi-chevron-left mr-3"></span>{{ question.order }}
            </button>
          </span>
        </p>
        <sound-player :url="question.audioTitle" role="questionTitle" tone="btn-outline-warning mr-3"></sound-player>
        <span v-html="questionTitre"></span>
        <!-- {{ questionTitre }} -->
      </div> <!-- #qst_cont_tete px-2 py-0 -->

      <div id="qst_cont_corps" class="card-body ">

        <div v-if="!question.typeContent" class="data_wait text-secondary text-center h5 w-100" :style="loader">
          {{ dataWait }}
        </div>

        <div v-if="question.typeContent==constants.typeContent.none" ref="rQstNone" id="qst_none" class="qst_body text-center " :class="getClass()" :style="getStyle()">
          &nbsp;
        </div>

        <div v-if="question.typeContent==constants.typeContent.text" ref="rQstText" id="qst_text" class="qst_body text-center " :class="getClass()" :style="getStyle()">
          <sound-player :url="question.audioMessage" role="questionMessage" tone="btn-outline-primary"></sound-player>
          <div v-if="question.isVignette==1"><img :src="question.vignetteUrl" ref="rVgt" id="qst_text_vgt" class="qst_image img-fluid position-relative m-0 p-0 h-auto mb-3 " :class="getClassVignette()" :alt="getVignetteName(0)" :title="getVignetteName(1)" @error="onVignetteError()"></div>
          <div class="qst_mssg text-left px-4" v-html="questionMessage"></div>
          <div id="qst_text_icon" class="text-center"><span class="oi oi-chevron-bottom"></span></div>
          {{ thisScrollEvent }}
        </div>

        <div v-if="question.typeContent==constants.typeContent.image" id="qst_image" class="qst_body text-center " :class="getClass()" :style="getStyle()">
          <img :src="question.urlImage" ref="rImg" class="qst_image img-fluid m-0 p-0 h-100 w-auto" :alt="getImageName(0)" :title="getImageName(1)" @error="onImageError()">
        </div>

        <div v-if="question.typeContent==constants.typeContent.video" id="qst_video" class="qst_body text-center " :class="getClass()" :style="getStyle()" :title="setTitle()">
          <video-player :url="question.urlVideo" :mode="modeShow"></video-player>
        </div>

        <div v-if="question.typeContent==constants.typeContent.doc" id="qst_doc" class="qst_body text-center " :class="getClass()" :style="getStyle()">
          <a :href="question.urlDoc" id="link_url_doc" class="btn btn-dark btn-lg m-md-5 p-5" :title="getDocName(1)" target="_blank" rel="noopener noreferrer">
            <img :src="urlDocIcon" id="url_doc" class="weblink_image mb-5" :alt="urlDocName" v-once width="320" height="180">
            <br><br>
            <span class="text-uppercase">
              <span class="oi oi-data-transfer-download mr-2"></span>
              {{ $t('question.seeDoc') }}
            </span>
          </a>
        </div>

        <div v-if="question.typeContent==constants.typeContent.html" id="qst_html" class="qst_body text-center " :class="getClass()" :style="getStyle()">
          <div v-if="Boolean(question.urlIsEmbed)" class="embed-responsive embed-responsive-1by1 div_iframe" :style="loader">
            <iframe class="embed-responsive-item" :src="question.urlHtml" :title="getUrlDomain(1)" allowfullscreen></iframe>
          </div>
          <a v-else :href="question.urlHtml" id="link_url_html" class="ui_tip btn btn-dark btn-lg m-md-5 p-5" :title="getUrlDomain(1)" target="_blank" rel="noopener noreferrer">
            <img :src="urlHtmlImage" id="url_html" class="weblink_image mb-5" alt="" width="320" height="180">
            <br><br>
            <span class="text-uppercase">
              <span class="oi oi-external-link mr-2"></span>
              {{ $t('question.seeHtml') }}
            </span>
          </a>
        </div>

      </div> <!-- #qst_cont_corps -->

      <div id="qst_cont_pied" class="card-footer text-muted">

        <div v-if="question.typeQuestion==constants.typeQuestion.noQuestion">
          <button type="submit" :title="btnSubmitTip" class="btn_page_submit btn btn-primary btn-block btn-lg ui_tip" @click.stop="save(null)"> <!-- #01# -->
            <span class="oi oi-chevron-right mr-2"></span>
            {{ $t('question.goNext') }}
          </button>
        </div>

        <div v-else-if="question.typeQuestion==constants.typeQuestion.open">
          <answer-open :question="question" @save="save" :key="keyOpen" :isfr="langFr"></answer-open>
          <button id="qst_btn_3" ref="QstBtn3" type="submit" :title="btnSubmitTip" class="btn_page_submit btn btn-primary btn-block btn-lg ui_tip" data-toggle="modal" data-target="#answer_open" @click="setAnswerStartTime()">
            <span class="oi oi-pencil mr-2"></span>
            {{ $t('question.goAnswer') }}
          </button>
        </div>

        <div v-else-if="question.typeQuestion==constants.typeQuestion.scq">
          <answer-scq :question="question" @save="save" :key="keyScq" :isfr="langFr"></answer-scq>
          <button id="qst_btn_1" ref="QstBtn1" type="submit" :title="btnSubmitTip" class="btn_page_submit btn btn-primary btn-block btn-lg ui_tip" data-toggle="modal" data-target="#answer_scq" @click="setAnswerStartTime()">
            <span class="oi oi-pencil mr-2"></span>
            {{ $t('question.goAnswer') }}
          </button>
        </div>

        <div v-else-if="question.typeQuestion==constants.typeQuestion.mcq">
          <answer-mcq :question="question" @save="save" :key="keyMcq" :isfr="langFr"></answer-mcq>
          <button id="qst_btn_2" ref="QstBtn2" type="submit" :title="btnSubmitTip" class="btn_page_submit btn btn-primary btn-block btn-lg ui_tip" data-toggle="modal" data-target="#answer_mcq" @click="setAnswerStartTime()">
            <span class="oi oi-pencil mr-2"></span>
            {{ $t('question.goAnswer') }}
          </button>
        </div>
        
        <div v-else-if="question.typeQuestion==constants.typeQuestion.upload">
          <answer-upload 
            :question="question" 
            :answerGrp="lesson.answerGrp"
            @save="save"
            :key="keyUpld"
            :isfr="langFr"
          ></answer-upload>
          <button id="qst_btn_5" ref="QstBtn5" type="submit" :title="btnSubmitTip" class="btn_page_submit btn btn-primary btn-block btn-lg ui_tip" data-toggle="modal" data-target="#answer_upload" @click="setAnswerStartTime()">
            <span class="oi oi-file mr-2"></span>
            {{ $t('question.goUpload') }}
          </button>
        </div>

      </div> <!-- #qst_cont_pied -->

    </div> <!-- #qst_cont -->

    {{ forceRefresh }}

  </div> <!-- #page_question -->
</template>

<script>
// interface.isQuestionFixedHeight
// https://getbootstrap.com/docs/4.2/utilities/embed/

import { constants } from '@/constants'
import TokensCheck from '@/router/tokensCheck'
import CountryFlag from "vue-country-flag"
import SoundPlayer from '@/components/misc/SoundPlayer'
import VideoPlayer from '@/components/misc/VideoPlayer'
import ModalDico from '@/components/misc/ModalDico'

import AnswerOpen from '@/components/question/AnswerOpen'
import AnswerScq from '@/components/question/AnswerScq'
import AnswerMcq from '@/components/question/AnswerMcq'
import AnswerUpload from '@/components/question/AnswerUpload'

export default {
  components: {
    TokensCheck,
    CountryFlag,
    AnswerOpen,
    AnswerScq,
    AnswerMcq,
    AnswerUpload,
    SoundPlayer,
    VideoPlayer,
    ModalDico,
  },
  data () {
    return {
      questions: [],
      question: {},
      questionTitre: '',
      questionMessage: '',
      answer: '',
      lessonStartTime: 0,
      lessonEndTime: 0,
      questionStartTime: 0,
      questionEndTime: 0,
      answerStartTime: 0,
      answerEndTime: 0,
      errorMsg: '',
      flag: 'fr',
      lang: 'fr',
      langFr: true,
      urlHtmlDomain: '',
      urlHtmlImage: constants.assets.iconEmptySvgCode,
      urlDocName: '',
      urlDocIcon: constants.assets.iconEmptySvgCode,
      qstFixedHeightBool: false,
      qstFixedHeightValue: 500,
      keyOpen: false,
      keyScq: false,
      keyMcq: false,
      keyUpld: false,
      isVignette: false,
      vignettePos: 'float-left',
      vignetteDim: 'w-50',
      vignetteMrg: 'mr-5',
      modeShow: false,
      loader: '',
      dataWait: '',
      btnSubmitTip: '',
      isDico: false,
      keyDico: false,
      isMediasTip: false,
      isNoStopLec: false,
    }
  },
  methods: {
    setQuestionEndTime() {
      //! @Fredo 12/12/2021 : obsolete, à supprimer après tests->validation
      this.questionEndTime = Date.now()
      // console.log('setQuestionEndTime', this.questionEndTime)
    },
    setAnswerStartTime() {
      this.answerStartTime = Date.now();
      // console.log('answerStartTime', this.answerStartTime)
    },
    onDicIconError(sId) {
      // let oDic = this.$refs.rDic;
      // let oDic = $('img#icn_dic');
      // oDic.src = this.constants.assets.iconLecDicoBlack;
      document.getElementById(sId).src = this.constants.assets.iconLecDicoBlack;
    },
    goBack() {
      // this.$router.go(-1)
      this.$router.push({ name: 'assignments' }); 
    },
    getClassTitle() {
      return { 'page_qst_title': this.lesson.audioTitle }
    },
    getClassTete() {
      return { 'qst_tete': this.question.audioTitle }
    },
    getClassVignette() {
      let aPos = ['float-left','float-right'];
      let aMrg = ['mr-4','ml-4'];
      let nPos = Number(this.question.vignettePos);
      this.vignettePos = aPos[nPos];
      this.vignetteMrg = aMrg[nPos];
      this.vignetteDim = 'w-' + Number(this.question.vignetteDim);
      return this.vignettePos + ' ' + this.vignetteMrg + ' ' + this.vignetteDim;
    },
    getClass() {
      return { 'overflow-auto fixed_height': this.qstFixedHeightBool }
    },
    getStyle() {
      var sHeight = '--hfixe:' + this.qstFixedHeightValue + 'px;';
      if (this.qstFixedHeightBool) return sHeight;
      return '';
    },
    getVignetteName(bTip) {
      if (bTip && !this.isMediasTip) return '';
      return f_getUrlFileName_s(this.question.vignetteUrl);
    },
    getImageName(bTip) {
      if (bTip && !this.isMediasTip) return '';
      return f_getUrlFileName_s(this.question.urlImage);
    },
    getDocName(bTip) {
      if (bTip && !this.isMediasTip) return '';
      return this.urlDocName;
    },
    getUrlDomain(bTip) {
      if (bTip && !this.isMediasTip) return '';
      return this.urlHtmlDomain;
    },
    onImageError() {
      var oImg = this.$refs.rImg;
      oImg.src = this.constants.assets.fondVertMediJpgFile;
    },
    onVignetteError() {
      var oVgt = this.$refs.rVgt;
      oVgt.src = this.constants.assets.fondVertMediJpgFile;
    },
    getKey(sId) {
      return sId + f_getRandomMinMax_n(100000000, 999999999);
    },
    setTitle() {
      if (!this.modeShow) this.btnSubmitTip = this.$t('question.btnSubmitTip');
    },
    waitData() {
      var nTime = 10000; // 1000 = 1 sec ; 10000 = 10 sec; 
      var sText = this.$t('assignments.noLessonFound');
      var oThis = this;
      setTimeout(function () {
        oThis.dataWait = sText;
        oThis.loader = '';
      }, nTime);
    },
    save(answer, event = null) {
      //* @Fredo : stop propagation d'un évènement (voir solution Vue ligne 65 - #01# )
      // https://fr.vuejs.org/v2/guide/events.html#Modificateurs-d%E2%80%99evenements
      if (event) event.stopPropagation();

      // Les dates/heures de fin de question/réponse
      var sAnswer = answer;
      let dNow = Date.now();
      this.answerEndTime = dNow;
      this.questionEndTime = dNow;
      if (this.question.final===1) this.lessonEndTime = dNow;

      var nNbrProps = this.question.props.length;
      var zkpNextQuestion = this.question.props[0].zkpNextQuestion;
      var isOk = false;

      // console.log('this.question.props', this.question.props);
      // console.log('sAnswer', sAnswer);
      // console.log('Question.vue Datas', this.data);

      let bNoAnsw = f_isEmpty_m(sAnswer);
      // let bNoAnsw = Boolean(answer === null);

      if (bNoAnsw) {
        // Si la réponse est nulle ou vide

        this.answerStartTime = 0;
        this.answerEndTime = 0;
        sAnswer = '0';

      } else {
        // Si la réponse n'est ni nulle ni vide, alors on traite les données

        if (this.question.typeQuestion == this.constants.typeQuestion.scq) {
          // Questions multiples / réponse unique (cercles d'option)

          const sProp = this.question.props.filter(prop => prop.zkp == sAnswer)[0];
          const nIndex = Number(sProp.index);
          // console.log('nPropIndex', nIndex);

          isOk = Boolean(sProp.isPropOk == 1);
          zkpNextQuestion = this.question.props[nIndex].zkpNextQuestion;

        } else if (this.question.typeQuestion == this.constants.typeQuestion.mcq) {
          // Questions multiples / réponses multiples (cases à cocher)

          // Lorsqu'on est sur un choix multiple / réponse multiple, on commence par récupérer
          // la première proposition "correcte" et la première "incorrecte"
          // normalement chacune contient le "zkpNextQuestion" nécessaire
          const sPropsOkZkpNext = this.question.props.filter(prop => prop.isPropOk == 1)[0].zkpNextQuestion;
          const sPropsNoZkpNext = this.question.props.filter(prop => prop.isPropOk != 1)[0].zkpNextQuestion;

          // Ensuite on récupère toutes les propositions "correctes" et toutes les réponses
          // de l'utilisateur, on les trie, on les convertie en texte, puis on les compare…
          let aPropsOkZkp = this.question.props.filter(prop => prop.isPropOk == 1).map(prp => prp.zkp);
          let sPropsOkZkp = aPropsOkZkp.sort().join('-');

          let aResponses = this.question.props.filter(prop => sAnswer.includes(prop.zkp)).map(prp => prp.zkp);
          let sResponses = aResponses.sort().join('-');

          // On compare les propositions "correctes" avec la réponse utilisateur
          isOk = Boolean((sPropsOkZkp.localeCompare(sResponses)) === 0);

          // Si la réponse est identique aux propositions, alors on prends la redirection Ok, sinon l'autre
          zkpNextQuestion = isOk ? sPropsOkZkpNext : sPropsNoZkpNext;

        } else if (this.question.typeQuestion==this.constants.typeQuestion.open) {
          // Questions et réponses libres (de type texte, date, heure et nombre)

          // Analyser une plage de valeurs ?
          var isRange = Boolean(this.question.isRepPlage);

          if (this.question.repLibreType === 4) {
            // Réponse libre de type nombre

            let nMin = this.question.repNombreOkMin;
            let nMax = this.question.repNombreOkMax;
            let bMin = f_isEmpty_m(nMin);
            let bMax = f_isEmpty_m(nMax);

            if (isRange && !bMin && !bMax) {
              isOk = Boolean((Number(sAnswer) >= Number(nMin)) && (Number(sAnswer) <= Number(nMax)));
            } else {
              isOk = Boolean(!bMin && (Number(sAnswer) === Number(nMin)));
            }

          } else if (this.question.repLibreType === 3) {
            // Réponse libre de type heure

            let nMin = this.question.repHeureOkMin;
            let nMax = this.question.repHeureOkMax;
            let bMin = f_isEmpty_m(nMin);
            let bMax = f_isEmpty_m(nMax);

            if (isRange && !bMin && !bMax) {
              let nYear = new Date().getFullYear();
              let sDate = nYear.toString().concat('/01/01');
              let sMin = sDate.concat(' ',nMin);
              let sMax = sDate.concat(' ',nMax);
              let sRep = sDate.concat(' ',sAnswer);
              let dMin = new Date(sMin);
              let dMax = new Date(sMax);
              let dRep = new Date(sRep);
              isOk = Boolean((dRep >= dMin) && (dRep <= dMax));
            } else {
              isOk = Boolean(!bMin && (sAnswer === nMin));
            }

      } else if (this.question.repLibreType === 2) {
            // Réponse libre de type date

            let nMin = this.question.repDateOkMin;
            let nMax = this.question.repDateOkMax;
            let bMin = f_isEmpty_m(nMin);
            let bMax = f_isEmpty_m(nMax);

            if (isRange && !bMin && !bMax) {
              let dMin = new Date(nMin);
              let dMax = new Date(nMax);
              let dRep = new Date(sAnswer);
              isOk = Boolean((dRep >= dMin) && (dRep <= dMax));
            } else {
              isOk = Boolean(!bMin && (sAnswer === nMin));
            }

          } else {
            // Réponse libre de type texte
            isOk = false;
          }

          // La redirection
          if ((this.question.repLibreType > 1) && (nNbrProps > 1)) {
            let nOk = Number(isOk);
            let nIdx = Math.abs(nOk - 1);
            // let nIdx = 0 + Boolean(isOk - 1);
            zkpNextQuestion = this.question.props[nIdx].zkpNextQuestion;
          }

        } else {
          // Ni réponse unique, ni réponse multiple, ni réponse libre… peut-être Upload ?

          isOk = Boolean(this.question.typeQuestion == this.constants.typeQuestion.upload);

        }
      } // bNoAnsw

      if (zkpNextQuestion) {
        // console.log('zkpNextQuestion', zkpNextQuestion);
      } else {
        console.error('zkpNextQuestion not found : ', zkpNextQuestion)
        alert('zkpNextQuestion is not defined. Please contact tutor.')
      }

      var isAnswerOk = Number(isOk);
      var isVueNewTable = this.$store.state.params.isVueNewTable;

      // Mémorisation des datas dans Fmp LREP
      this.model.saveAnswer(
        this.question, this.user, this.lesson, 
        sAnswer, this.lessonStartTime, this.lessonEndTime, this.questionStartTime, this.questionEndTime, this.answerStartTime, this.answerEndTime, isAnswerOk, isVueNewTable);

      // Question suivante
      this.getNextQuestion(zkpNextQuestion);

    },
    getNextQuestion(zkpNextQuestion) {
      this.answer = ''

      // On enlève tout éventuelle flêche de scroll présente dans le texte du message
      this.$nextTick(function () {
        let oTxt = document.getElementById('qst_text');
        oTxt.classList.remove('scroll_start');
        oTxt.classList.add('scroll_end');
      })

      // On mémorise la liste des Zkp des questions visitées
      f_addQstZkpPrev_v(this.question.zkp);
      // console.log('aQstZkpPrevList', aQstZkpPrevList);

      if (this.question.final===1) {
        // On nettoie l'historique de navigation
        f_cleanQstZkpPrev_v();
        
        //* Fredo 16/08/2023 : on utilise le script de fin de leçon suivant le nouvelle architecture
        const isVueNewTable = this.params.isVueNewTable;
        // console.log('isVueNewTable', Number(isVueNewTable));

        // Si nouvelle architecture activée on lance le nouveau script de fin de leçon… sinon l'ancien
        if (isVueNewTable) {
          this.model.runScript('LRET_js', '2023_VUEJS_LeconFin_Job', this.lesson.answerGrp)
        } else {
          // Fredo 16/12/2021 : on se place directement dans le modèle 'LREP_js' et non plus dans 'lapr_js'
          this.model.runScript('LREP_js', '2022_VUEJS_LeconFin_Set', this.lesson.answerGrp)
        }

        // delete the uploaded files on the server
        const url = constants.project.path + '/del_upfiles.php?user_zkp=' + this.user.zkp
        fetch(url)
        .then(console.log('files cleaned'))
        .catch(error => console.error('fetch cleanup', error))
        
        // bascule vers "Patience.vue"
        var oParams = {
          sTitlePage: this.lesson.name,
          sTextHeader: null,
          sTextFooter: null,
          nTimeout: null,
          sRouteName: null,
        };
        this.$router.push({ name: 'patience', params: oParams});

      } else {

        // Est-ce que tout est OK avec les tokens ?
        var isTokensCheck = TokensCheck.getTokensCheck();

        // Si tout OK avec les token, on affiche la question suivante, 
        // sinon on retourne au formulaire de connexion
        if (isTokensCheck) {
          this.question = this.questions.filter(question => (question.zkp == zkpNextQuestion))[0]
          this.model.saveCurrQst(this.question, this.lesson)
          this.questionStartTime = Date.now();
        } else {
          this.$router.push({name: 'connect'});
        }

      }
    },
    getPrevQuestion() {
      // On affiche la diapo préscedente
      if (this.modeShow) {
        this.answer = ''
        const zkpPrevQuestion = f_getQstZkpPrev_s();
        this.question = this.questions.filter(question => (question.zkp == zkpPrevQuestion))[0]
      }
    },
    setPreloads() {
      // vignetteUrl ; urlImage ; urlVideo ; urlHtmlThumbn
      //  urlDoc ; audioTitle ; audioMessage ; audioQuestion
      if (this.questions.length) {
        var aUrls = [];
        for (const qst of this.questions) {
          if (qst.vignetteUrl) aUrls.push({'as':'image','url':qst.vignetteUrl});
          if (qst.urlImage) aUrls.push({'as':'image','url':qst.urlImage});
          if (qst.urlHtmlThumbn) aUrls.push({'as':'image','url':qst.urlHtmlThumbn});
          if (qst.urlVideo) aUrls.push({'as':'video','url':qst.urlVideo});
          if (qst.urlDoc) aUrls.push({'as':'document','url':qst.urlDoc});
          if (qst.audioTitle) aUrls.push({'as':'audio','url':qst.audioTitle});
          if (qst.audioMessage) aUrls.push({'as':'audio','url':qst.audioMessage});
          if (qst.audioQuestion) aUrls.push({'as':'audio','url':qst.audioQuestion});
        }
        if (aUrls.length) this.$store.commit('setQuestionsPreload', aUrls);
      }

    },
    getQuestions() {
      this.waitData();
      this.$i18n.locale = this.lesson.lang
      this.model.getQuestions(this.lesson.zkp)
      .then((questionsSuccess) => {
        this.questions = questionsSuccess
        if(!this.lesson.answerGrp) {
          let sNow = f_getDateTime_ISO_s().toString();
          this.lesson.answerGrp = this.user.zkp + '-' + this.lesson.zkp + '-' + this.lesson.zkf_ses + '-' + sNow;
          this.model.runScript('LAPR_js', '2022_VUEJS_GroupeIds_Get', this.lesson.zkp_lapr + '|' + this.lesson.answerGrp)
        }
        if (this.lesson.currQstZkp=='') {
          this.question = this.questions.filter(question => question.order == 1)[0]
        } else {
          this.question = this.questions.filter(question => question.zkp == this.lesson.currQstZkp)[0]
        }
        this.questionStartTime = Date.now();
        this.setPreloads();
      })
      .catch((questionsError) => {
        console.error(questionsError)
        this.errorMsg = questionsError.messages[0].message
      })
    },
    getThumb(sSize = 320) {
      // https://developer.mozilla.org/fr/docs/Glossary/Truthy
      this.urlHtmlDomain = f_getUrlDatas_s(this.question.urlHtml);
      var sThumbn = this.question.urlHtmlThumbn;
      if (sThumbn) {
        this.urlHtmlImage = sThumbn;
      } else {
        //* Fonction pour afficher une miniature (thumbnail) du site pointé 
        //* via un service en ligne 'https://thumbnail.ws/'
        // https://api.thumbnail.ws/api/API-KEY/thumbnail/get?width=320&url=SITE-URL
        // On construit l'Url du service pour récupérer l'Url de l'image du site
        var sSite = "https://api.thumbnail.ws/api/";
        //* @Fredo : Clé Api perso, il faudra en générer une spécifique pour InFormat
        var sApiKey = "aba17762d579f649dc00cb17ee81de912dc6a8cb36e6"; 
        var sReq = "/thumbnail/get?width=" + sSize + "&url=";
        var sUrl = this.question.urlHtml;
        this.urlHtmlImage = sSite + sApiKey + sReq + sUrl;
      }
    },
    getFileIcon() {
      //* Fonction pour récupérer le nom du fichier à télécharger
      //* et pour générer l'icône du type de fichier par son extension
      this.urlDocName = f_getUrlFileName_s(this.question.urlDoc);
      this.urlDocIcon = f_setFileIcon_s(this.question.urlDoc, constants.assets.iconFileSvgCode);
    },
    onScrollEvent() {
      //* Fonction pour gérer le scroll des contenus texte
      // https://vuejs.org/v2/guide/reactivity.html#Async-Update-Queue
      this.$nextTick(function () {
        var oObj = this.$refs.rQstText;
        f_onScrollStart_v(oObj);
        oObj.addEventListener("scroll", f_onScrollEnd_v);
      })
    },
    showAnswer() {
      this.$nextTick(() => {
        var sSel = 'button#qst_btn_' + this.question.typeQuestion;
        setTimeout(function() {
          $(sSel).focus().click();
        }, 500);
      });
    },
    thisScrollTop() {
      if ((this.question.typeContent == constants.typeContent.text) && this.qstFixedHeightBool) {
        this.$nextTick(function () {
          f_setScrollTopByClass_v("qst_body");
        });
      }
    },
  }, // methods
  computed: {
    model() {
      return this.$store.state.model
    },
    user() {
      return this.$store.state.user
    },
    lesson() {
      return this.$store.state.lesson
    },
    lessonStart() {
      return this.$store.state.lessonStart
    },
    urlVidel() {
      return 0
    },
    constants() {
      return constants
    },  
    params() {
      return this.$store.state.params
    },  
    thisScrollEvent() {
      if ((this.question.typeContent == constants.typeContent.text) && this.qstFixedHeightBool) this.onScrollEvent();
      return '';
    },
    forceUpdate() {
      this.langFr = Boolean(this.lesson.lang.toLowerCase() === "fr");
      // console.log("langFr", this.langFr.toString());
      // console.log("title", this.question.title);
      this.questionTitre = (this.langFr) ? f_setCleanSpacesFr_s(this.question.title) : this.question.title;
      if (this.question.message) this.questionMessage = nl2br(this.question.message, true, false); 
      if (this.question.urlDoc) this.getFileIcon();
      this.urlHtmlImage = constants.assets.iconEmptySvgCode;
      if (!this.keyOpen) this.keyOpen = this.getKey('QstOpen');
      if (!this.keyScq) this.keyScq = this.getKey('QstScq');
      if (!this.keyMcq) this.keyMcq = this.getKey('QstMcq');
      if (!this.keyUpld) this.keyUpld = this.getKey('QstUpld');
      if (!this.keyDico) this.keyDico = this.getKey('LecDico');
      this.thisScrollTop();
      return '';
    },
    forceRefresh() {
      if (this.question.urlHtml) this.getThumb();
      if ((this.question.typeContent == constants.typeContent.text) && this.question.message && this.qstFixedHeightBool) this.onScrollEvent();
      if (this.question.typeContent == constants.typeContent.none) this.showAnswer();
      this.btnSubmitTip = '';
      this.questionStartTime = Date.now()
      this.questionEndTime = 0;
      this.answerStartTime = 0;
      this.answerEndTime = 0;
      this.isVignette = Boolean(this.question.isVignette);
      this.modeShow = (Boolean(this.lesson.modeShow) || Boolean(this.lesson.isEvaluation)) && (this.question.order > 1) && (aQstZkpPrevList.length > 0);
      this.isDico = Boolean(this.lesson.dictionary.length);
      this.isNoStopLec = Boolean(this.lesson.isNoStopLec);
      // console.log("params", this.params);
      return '';
    },
  }, // computed
  mounted: function() {
    this.keyOpen = false;
    this.keyScq = false;
    this.keyMcq = false;
    this.keyUpld = false;
    this.keyDico = false;
    this.isDico = false;
    this.getQuestions();
    this.urlHtmlImage = constants.assets.iconEmptySvgCode;
    this.urlDocIcon = constants.assets.iconEmptySvgCode;
    this.lang = this.lesson.lang.toUpperCase();
    // this.flag = this.lesson.lang === 'en' ? 'gb' : this.lesson.lang;
    this.flag = this.lesson.country;
    this.qstFixedHeightValue = (this.params.qstFixedHeightValue) ? this.params.qstFixedHeightValue : constants.interface.qstFixedHeightValue;
    this.qstFixedHeightBool = Boolean(this.qstFixedHeightValue > constants.interface.qstFixedHeightLimit);
    this.lessonStartTime = this.lessonStart;
    this.lessonEndTime = 0;
    this.loader = "background-image: url(" + constants.assets.load_5bc + ");";
    this.dataWait = this.$t("assignments.dataWait");
    this.btnSubmitTip = '';
    this.isMediasTip = this.params.isMediasTip;
  },
}
</script>

<style scoped>
  .data_wait {
    height: 200px !important;
    background-position: center 50px;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .div_iframe {
    background-position: center top;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .qst_index {
    display: none;
    text-indent: 0 !important;
    margin: -0.3rem -0.2rem 0 2rem !important;
  }
  .qst_index > .badge > .btn {
    font-size: 65%;
    letter-spacing: 1px;
    font-weight: bold !important;
    text-indent: 0 !important;
  }
  .qst_index > .badge > .btn > .oi {
    font-size: 85%;
  }
  #page_question > #qst_cont > #qst_cont_tete:hover > .qst_index {
    display: block !important;
  }
  .page_qst_title {
    padding-left: 56px !important;
    text-indent: -56px !important;
  }
  .qst_tete {
    padding-left: 76px !important;
    text-indent: -56px !important;
  }
  .qst_mssg {
    font-size: 1.6rem !important;
    line-height: 2.4rem !important;
  }
  .qst_image {
    object-fit: contain !important;
  }
  .weblink_image {
    border: none !important;
    outline: none !important;
  }
  .qst_body {
    position: relative;
    padding-top: 0.25rem !important;
  }
  .qst_body.fixed_height {
    height: var(--hfixe) !important;
  }
  .qst_body > #qst_text_icon {
    display: none !important;
    font-size: 0.5rem;
  }
  .qst_body.fixed_height > #qst_text_icon {
    color: #090 !important;
    font-size: 6rem;
    opacity: 0.5;
    left: 50%;
    bottom: -30px;
    position: -webkit-sticky;
    position: sticky;
  }
  .qst_body.fixed_height.scroll_start > #qst_text_icon {
    display: block !important;
  }
  .qst_body.fixed_height.scroll_end > #qst_text_icon {
    display: none !important;
  }

  /* Large devices (desktops, less than 1200px) */
  @media (max-width: 1199.98px) { 
    .qst_body.fixed_height {
      height: calc(var(--hfixe) * 0.9) !important;
    }
  }
  /* Medium devices (tablets, less than 992px) */
  @media (max-width: 991.98px) { 
    .qst_body.fixed_height {
      height: calc(var(--hfixe) * 0.8) !important;
    }
  }
  /* Small devices (landscape phones, less than 768px) */
  @media (max-width: 767.98px) { 
    .qst_body.fixed_height {
      height: calc(var(--hfixe) * 0.7) !important;
    }
    .page_qst_title {
      padding-left: 44px !important;
      text-indent: -44px !important;
    }
    .qst_tete {
      padding-left: 64px !important;
      text-indent: -44px !important;
    }
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) { 
    .qst_body.fixed_height {
      height: calc(var(--hfixe) * 0.6) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/question/Question.vue